import Image from "next/image";

const NotFound = () => {
	return (
		<section className="error-area relative py-16 md:py-20 lg:py-24">
			<div className="container pb-12 md:pb-14 lg:pb-20">
				<div className="error-thumb mx-auto max-w-[900px] text-center">
					<Image
						src="/images/404-illustration.svg"
						alt="Resource not found"
						width={1080}
						height={1080}
					/>
				</div>
				<div className="pt-10 text-center text-2xl font-bold sm:text-3xl md:pt-16 md:text-4xl lg:pt-20 lg:text-5xl">
					Resource not found
				</div>
			</div>
		</section>
	);
};

export default NotFound;
